import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/login/login.vue"
import customerLogin from "@/views/login/customerLogin.vue"
import mobileLogin from "@/views/login/mobileLogin.vue"
import userHome from "@/views/userFile/home.vue"
import projectDetails from "@/views/userFile/projectDetails.vue"
import clientHome from '@/views/clientFile/clientHome.vue'
import mobileClient from '@/views/clientFile/mobileClient.vue' 
import tab from '@/views/tab/tab.vue'
import transferView from '@/views/transferFile/transferView.vue'
import urllink from '@/views/wechat/urllink.vue'
import link from '@/views/wechat/link.vue'
import pay from '@/views/pay/pay.vue'
import paySuccess from '@/views/pay/paySuccess.vue'
import userHelpDetail from '@/views/userHelp/userHelpDetail.vue'


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  
  {
    path: "/",
    name: "Login",
    component: Login
  },{
    path: "/userHome",
    name: "userHome",
    component:userHome
  },{
    path: "/projectDetails",
    name: "projectDetails",
    component:projectDetails
  },{
    path: "/customerLogin",
    name: "customerLogin",
    component:customerLogin
  },{
    path: "/mobileLogin",
    name: "mobileLogin",
    component:mobileLogin
  },{
    path: "/clientHome",
    name: "clientHome",
    component:clientHome
  },{
    path: "/mobileClient",
    name: "mobileClient",
    component:mobileClient
  },{
    path: "/tab",
    name: "tab",
    component:tab
  },{
    path: "/transferView",
    name: "transferView",
    component:transferView
  },{
    path: "/urllink",
    name: "urllink",
    component:urllink
  },{
    path: "/link",
    name: "link",
    component:link
  },
  {
    path: "/pay",
    name: "pay",
    component:pay
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    component:paySuccess
  },
  {
    path: "/userHelpDetail",
    name: "userHelpDetail",
    component:userHelpDetail
  },
  
];

const router = new VueRouter({
  mode:'history',
  base:'/home/',
  // base:'/static/home/',
  routes
});

export default router;
